import { AtlasNode } from './atlas-node';

const BASE_SELECTOR: string = '.atlas-map-wrapper';
const SAVE_BUTTON_SELECTOR: string = '[data-save]';
const DRAGSCROLL_ID: string = 'atlas-map__img';
const MAPSELECT_SELECTOR: string = '#atlas-map-selection';
const CLOSEFULLVIEW_BUTTON_SELECTOR: string = '#disable-fullscreen';

export class AtlasMapUI {

    public static readonly ATLAS_SLOT_SELECTOR: string = '.atlas-map__change--slot';
    public static readonly ATLAS_CLUSTER_SLOT: string = '#atlas-map__cluster--slot';
    public static readonly ATLAS_SLOT_DISPLAY: string = '#atlas-map__current--slot';

    public constructor(public $base: JQuery) {

    }

    public getSelectedMapId(): number {
        return $('#atlas-map-selection').val() as number;
    }

    public onSaveButtonClick(callback: () => void) {
        $(SAVE_BUTTON_SELECTOR).on('click', e => {
            e.preventDefault();
            callback();
        });
    }


    public onWindowResize(callback: () => void) {
      $(window).on('resize', () => {
        callback();
      })
    }

    public getMapImageSize() : { height: number, width: number } {
      return { height: this.$base.find('.img-responsive').height(), width: this.$base.find('.img-responsive').width() };
    }

    public setMapImageSize(size: { height: number, width: number } ) {
      this.$base.find('.atlas-map__grid').css('height', size.height);
      this.$base.find('.atlas-map__grid').css('width', size.width);
    }

    /**
     * onChangeMapSelection
     */
    public onChangeMapSelection(callback: () => void) {
        $(MAPSELECT_SELECTOR).on('change', (e) => {
            e.preventDefault();
            callback();
        });
    }

    /**
     * Listen to button click
     * @param callback
     */
    public onFullScreenButtonClick(callback: () => void) {
        document
            .getElementById('enable-fullscreen')
            .addEventListener('click', (e) => {
                e.preventDefault();
                callback();
            });
    }

    public onCloseButtonClick(callback: () => void) {
        $(CLOSEFULLVIEW_BUTTON_SELECTOR).on('click', (e) => {
                e.preventDefault();
                callback()
            }
        );
    }

    public onSlotAfterChange(callback: (event: JQuery.TriggeredEvent) => void) {
        $(document).on('change', AtlasMapUI.ATLAS_SLOT_SELECTOR, (event: JQuery.TriggeredEvent) => {
            callback(event);
        });
    }

    public onSlotBeforeChange(callback: (event: JQuery.TriggeredEvent) => void) {
        $(document).on('click', AtlasMapUI.ATLAS_SLOT_SELECTOR, (event: JQuery.TriggeredEvent) => {
            callback(event);
        });
    }

    public onAfterAtlasMapRender(callback: () => void) {
        window.addEventListener('render', (event: CustomEvent) => {
            if(event.detail === AtlasNode.name) {
                callback();
            }
        });
    }
}

export function createMapInstances(): AtlasMapUI[] {
    const instances: AtlasMapUI[] = [];
    $(BASE_SELECTOR).each((index, el) => {
        instances.push(new AtlasMapUI($(el)));
    });

    return instances;
}
